<template>
    <div>
        <div class="contactConfiguration-title">
            <Breadcrumb>
                <BreadcrumbItem to="/alarmContact">{{ $t('alarm_contact.alarmContact') }}</BreadcrumbItem>
                <BreadcrumbItem>{{ $t('alarm_contact.contactConfiguration') }}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <add-contact-configuration></add-contact-configuration>
    </div>
</template>

<script>
    import AddContactConfiguration from '../contact_configuration/AddContactConfiguration'
    export default {
        name: 'ContactConfiguration',
        components: {
            AddContactConfiguration
        }
    }
</script>

<style scoped>
    .contactConfiguration-title
    {
        width: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/alarm_contact/alarm_contact_group/contact_configuration/ContactConfiguration.vue